export default {
  LAST_ROUTE_BEFORE_MAINTENANCE_STORAGE_KEY: 'last-route-before-maintenance'
};
